<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUCT_SNS_MODULE } from '@/state/modules/productSNS'
import { lookupMethods, productSNSMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";
import ImageUploader from '@/components/upload-file';

/**
 * Tabs & accordions component
 */
export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.productSNS")]),
    },
    components: { Layout, PageHeader, Multiselect, ImageUploader },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-cert-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_SNS_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        data() {
            return this.$store.state.productSns.details;
        },
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
    },
    data() {
        return {
            title: i18n.t("label.updateX", [i18n.t("module.productSNS")]),
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.productSNS"),
                    href: "/product-sns",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t('module.productSNS')]),
                    active: true,
                },
            ],
            submitted: false,
            permissions: sessionHelper.getPermissions(),
            updatePermission: null,
            readPermission: null,
            statusDdl: ddlHelper.getActivationStatus(true),
        };
    },
    validations: {
        data: {
            // name: { required },
            productID: { required }
        },
    },
    async created() {
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SNS_SEARCH);
        this.searchCriteriaProductSpecial = sessionHelper.retrieveSearch(SESSION.PRODUCT_SPECIAL_SEARCH);
        
        if (this.searchCriteriaProductSpecial != null && this.searchCriteriaProductSpecial != '') {
            this.isCloseWhenSuccess = this.searchCriteriaProductSpecial.isCloseWhenSuccess; 
        }
        else {
            this.isCloseWhenSuccess = false;
        }

        await this.validPermissions();
        this.lookupProduct({ hasOptionAll: false });
        await this.getProductSnsData();
    },
    methods: {
        ...productSNSMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PSDS_PSDSU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PSDS_PSDSR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }
        },
        updateImage(image) {
            this.data.file = image[0].file;
        },

        removeImage() {
            this.data.file = null;
        },

        async getProductSnsData() {
            this.isLoading = true;
            if (this.readPermission == true) {
                await this.getProductSNS({ id: this.searchCriteria.selectedRecordId });
            }
            this.isLoading = false;
        },

        async requestUpdate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.data.$invalid) {
                console.log("Validation failed");

                for (const field in this.$v.data) {
                    if (this.$v.data[field].$invalid) {
                        console.log(`Validation failed for: ${field}`);
                    }
                }
                return;
            } else {
                let isCloseWhenSuccess = this.isCloseWhenSuccess; 

                let data = {
                    id: this.data.uuid,
                    name: this.data.name,
                    productID: this.data.productID.value,
                    file: this.data.file,
                };
                if (this.updatePermission == true) {
                    await this.updateProductSNS({ data, isCloseWhenSuccess });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="requestUpdate" v-if="readPermission == true">
                            <ImageUploader :initialImages="[data.file]" :multiple="false"
                                :buttonText="'Choose Product Cert'" @images-changed="updateImage"
                                @images-removed="removeImage" />

                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="productID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.product')" label-for="productID">
                                        <multiselect v-model="data.productID" deselect-label="Can't remove this value"
                                            track-by="value" label="text" placeholder="Select one" :options="productDdl"
                                            :searchable="true" :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.data.productID.required" class="invalid-feedback"
                                            style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <!-- <div class="col-md-6">
                                    <b-form-group id="name" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.name')" label-for="name">
                                        <b-form-input id="name" v-model.trim="data.name" :class="{
                                            'is-invalid': submitted && !$v.data.name.required
                                        }"></b-form-input>
                                        <div v-if="submitted && !$v.data.name.required" class="invalid-feedback"
                                            style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("label.name")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div> -->
                            </div>

                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.create || updatePermission != true">
                                    {{ $t("label.updateX", [$t("module.productSNS")]) }}
                                </button>

                                <a :href="data.oldFile" target="_blank"
                                    class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" v-if="data.oldFile != null">
                                    {{ $t("label.download") }}
                                </a>

                                <a href="javascript:void(0);" class="btn btn-primary w-md waves-effect waves-light"
                                    style="margin-right: 10px; background-color: grey;" type="submit" v-else>
                                    {{ $t("label.download") }}
                                </a>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>